// export const ASSETS_HOST = isChrome ? `${ process.env.ASSETS_HOST }/statics-low` : `${ process.env.ASSETS_HOST }/statics`
export const ASSETS_HOST = `${process.env.ASSETS_HOST}/statics`
export const MEDIA_HOST = process.env.MEDIA_HOST
  ? process.env.MEDIA_HOST
  : `${process.env.ASSETS_HOST}/statics`

export const buildUri = (url) => {
  return `${ASSETS_HOST}${url}`
}
export const buildUriMedia = (url) => {
  return `${MEDIA_HOST}${url}`
}
export const buildModelsUri = (url) => {
  return `${process.env.ASSETS_HOST}/${url}`
}
